module.exports = __webpack_public_path__ + "media/images/icons/admissions-guidance-761f87063cef1657204832fb3ba4ecb1.svg";